var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dropdown Icon",
    clipPath: "url(#clip0_2184_2349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.66659 9.7777C5.66659 10.6368 6.36303 11.3333 7.22214 11.3333H8.66659C9.58706 11.3333 10.3333 10.5871 10.3333 9.66659C10.3333 8.74611 9.58706 7.99992 8.66659 7.99992H7.33325C6.41278 7.99992 5.66659 7.25373 5.66659 6.33325C5.66659 5.41278 6.41278 4.66659 7.33325 4.66659H8.7777C9.63681 4.66659 10.3333 5.36303 10.3333 6.22214M7.99992 3.66659V4.66659M7.99992 11.3333V12.3333M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2184_2349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.5580c6637d92a57b235600d89820108f.svg";
export { ForwardRef as ReactComponent };